//  __  __       _
// |  \/  | __ _(_)_ __
// | |\/| |/ _` | | '_ \
// | |  | | (_| | | | | |
// |_|  |_|\__,_|_|_| |_|
//

export const main = {
	empty: mainEmpty
};

function mainEmpty(query) {
	return `
		<div class="gs-FormSearch-empty">
			<p class="color-stone mb-3 mb-lg-2">
				<strong>No results found.</strong>
				Need something specific? Our software experts can help you find the best system for your needs.
			</p>

			<div class="d-flex flex-column flex-sm-row align-items-sm-center">
				<div class="mr-sm-3 pr-sm-3 br-sm-dotted b--slate">
					<button type="button" role="button" data-gs-modal-template="recommendations" class="gs-Button gs-Button--yellow gs-Button--small gs-Button-lg--medium">
						Software Recommendations
					</button>
				</div>
				<div class="pt-3 pt-sm-0 pr-lg-5 color-stone font-size-smaller text-lighter leading-tighter">
					<strong>Or call (800) 827-1151</strong>
					to speak with an independent software expert now.
				</div>
		</div>
	`;
}



//   ____      _                        _
//  / ___|__ _| |_ ___  __ _  ___  _ __(_) ___  ___
// | |   / _` | __/ _ \/ _` |/ _ \| '__| |/ _ \/ __|
// | |__| (_| | ||  __/ (_| | (_) | |  | |  __/\__ \
//  \____\__,_|\__\___|\__, |\___/|_|  |_|\___||___/
//                     |___/

export const category = {
	header: categoryHeader,
	suggestion: categorySuggestion
};

function categoryHeader(query, results) {
	return `
		<div class="gs-FormSearch-resultsHeader">
			<div class="gs-FormSearch-resultsHeaderLabel">
				Software Guides & Expert Research
			</div>
			<div class="gs-FormSearch-resultsHeaderInfo">
				<a href="/categories/">Browse all software guides &rarr;</a>
			</div>
		</div>
	`;
}

function categorySuggestion(suggestion) {
	return `
		<div class="gs-FormSearch-resultWrapper">
			<div class="gs-FormSearch-resultLabel">
				${suggestion.categoryName}
			</div>
			<div class="gs-FormSearch-resultInfo">
				${pluralize(suggestion.productCount, 'product', 'products')}
			</div>
		</div>
	`;
}



//  ____                _            _
// |  _ \ _ __ ___   __| |_   _  ___| |_ ___
// | |_) | '__/ _ \ / _` | | | |/ __| __/ __|
// |  __/| | | (_) | (_| | |_| | (__| |_\__ \
// |_|   |_|  \___/ \__,_|\__,_|\___|\__|___/
//

export const product = {
	header: productHeader,
	suggestion: productSuggestion
};

export function productHeader(query, results) {
	let more = '';
	// if (results.nbHits > results.hitsPerPage) more = `
	// 	<a href="/products/?q=${query.query}">
	// 		List all ${results.nbHits} products &rarr;
	// 	</a>
	// `;

	return `
		<div class="gs-FormSearch-resultsHeader">
			<div class="gs-FormSearch-resultsHeaderLabel">
				Software Products
			</div>
			<div class="gs-FormSearch-resultsHeaderInfo">
				${more}
			</div>
		</div>
	`;
}

export function productSuggestion(suggestion) {
	return `
		<div class="gs-FormSearch-resultWrapper">
			<div class="gs-FormSearch-resultLabel">
				${suggestion.productName}
			</div>
			<div class="gs-FormSearch-resultInfo">
				${rating(suggestion.rating)}
			</div>
		</div>
	`;
}



//  _____                          _   _
// |  ___|__  _ __ _ __ ___   __ _| |_| |_ ___ _ __ ___
// | |_ / _ \| '__| '_ ` _ \ / _` | __| __/ _ \ '__/ __|
// |  _| (_) | |  | | | | | | (_| | |_| ||  __/ |  \__ \
// |_|  \___/|_|  |_| |_| |_|\__,_|\__|\__\___|_|  |___/
//

function pluralize(val, singular, plural) {
	let suffix = (val == 1 ? singular : plural);
	return `${val} ${suffix}`;
}

function rating(val) {
	let stars = '';

	for (let i = 1; i <= 5; i++) {
		let starClass = 'is-dim';
		if (!val) starClass = 'is-missing';
		if (Math.round(val ?? 0) >= i) starClass = 'is-lit';
		stars += `<span class="${starClass}">&#9733;</span>`;
	}
	return stars;
}
